import helper from '@/libs/forms';
import PROPERTY_TYPES from '@/components/profile/sections/tabs/real_estate/resources/propertyTypes';
import VueFormGenerator from 'vue-form-generator';

const options = {
  type: Object.keys(PROPERTY_TYPES).map(key => ({
    id: key,
    name: PROPERTY_TYPES[key],
  })),
};

const ownershipPercentageField = () => {
  const field = helper.simpleInput(
    'number',
    '% Ownership:',
    '51.00',
    'ownershipPercentage',
    true,
    6,
  );
  field.max = 100;
  field.min = 0.01;
  return field;
};

const dateValidator = (value, field, model) => (
  new Date(value) < new Date(model.purchaseDate) ?
    ['This date is less than the Purchase date, please change it.'] :
    VueFormGenerator.validators.date(value, field, model)
);

const getFields = () => [
  helper.splitAddress('Property Address', 'propertyAddress'),
  ownershipPercentageField(),
  helper.simpleSelect(
    'Property Type',
    'propertyType',
    true,
    options.type,
    null,
    6,
  ),
  helper.date(
    'Purchase Date',
    null,
    'purchaseDate',
    true,
    6,
    null,
    false,
    true,
  ),
  helper.currency('Purchase Price', 'purchasePrice', true, 6),
  helper.date('Sale Date', null, 'saleDate', true, 6, null, false, true, dateValidator),
  helper.currency('Sale Price', 'salePrice', true, 6),
];

export default {
  schema: onSubmit => ({
    fields: getFields(onSubmit),
  }),
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/real_estate/schemas/operationSchema.js